var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-search__results" },
    [
      _vm.searchResponse
        ? [
            _vm.shortcuts && _vm.resultSetSetting === _vm.resultKinds.all
              ? _c(
                  "div",
                  { staticClass: "global-search__shortcuts" },
                  _vm._l(_vm.shortcuts, function (shortcut, key) {
                    return _c("global-quicksearch-shortcut", {
                      key: key,
                      attrs: { shortcut: shortcut },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.searchResponse.boards &&
            (_vm.resultSetSetting === _vm.resultKinds.all ||
              _vm.resultSetSetting === _vm.resultKinds.boards)
              ? [
                  _vm.searchResponse.boards.resultCount
                    ? [
                        _c("search-result-set", {
                          attrs: { "result-set": _vm.searchResponse.boards },
                        }),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.searchResponse.decor &&
            (_vm.resultSetSetting === _vm.resultKinds.all ||
              _vm.resultSetSetting === _vm.resultKinds.decor)
              ? [
                  _vm.searchResponse.decor.resultCount
                    ? [
                        _c("search-result-set", {
                          attrs: { "result-set": _vm.searchResponse.decor },
                        }),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.searchResponse.structure &&
            (_vm.resultSetSetting === _vm.resultKinds.all ||
              _vm.resultSetSetting === _vm.resultKinds.structure)
              ? [
                  _vm.searchResponse.structure.resultCount
                    ? [
                        _c("search-result-set", {
                          attrs: { "result-set": _vm.searchResponse.structure },
                        }),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.searchResponse.reference &&
            (_vm.resultSetSetting === _vm.resultKinds.all ||
              _vm.resultSetSetting === _vm.resultKinds.reference)
              ? [
                  _vm.searchResponse.reference.resultCount
                    ? [
                        _c("search-result-set", {
                          attrs: { "result-set": _vm.searchResponse.reference },
                        }),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.searchResponse.downloads &&
            (_vm.resultSetSetting === _vm.resultKinds.all ||
              _vm.resultSetSetting === _vm.resultKinds.downloads)
              ? [
                  _vm.searchResponse.downloads.resultCount
                    ? [
                        _c("search-result-set", {
                          attrs: { "result-set": _vm.searchResponse.downloads },
                        }),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.searchResponse.page &&
            (_vm.resultSetSetting === _vm.resultKinds.all ||
              _vm.resultSetSetting === _vm.resultKinds.page)
              ? [
                  _vm.searchResponse.page.resultCount
                    ? [
                        _c("search-result-set", {
                          attrs: { "result-set": _vm.searchResponse.page },
                        }),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }